import { CopyIcon } from '@radix-ui/react-icons';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { truncateUserId } from '@/utils/formatUserId';

export function CopyUserId({
  id,
  className,
}: {
  id: string;
  className?: string;
}) {
  return (
    <span className={className}>
      <span className="font-mono text-xs text-muted-foreground">
        ID {truncateUserId(id)}
      </span>
      <Button
        type="button"
        variant="ghost"
        size="iconSm"
        className="ml-1 shrink-0 text-foreground"
        onClick={async (event) => {
          event.preventDefault();
          event.stopPropagation();
          await navigator.clipboard.writeText(id);
          toast.success('ID copied');
        }}
        aria-label="Copy user ID"
      >
        <CopyIcon className="h-3.5 w-3.5 shrink-0 text-foreground" />
      </Button>
    </span>
  );
}
